import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ModalController, NavController } from '@ionic/angular';
import { UiBsTranslateService } from '@wlp/ui-bs-translate';
import { DateValidator } from '@wlp/ui-bs-util';
import * as moment from 'moment';
import { LayoutConfigModel } from 'src/app/core/layout/models/layout-config.model';
import { LayoutConfigService } from 'src/app/core/layout/services/layout-config.service';
import { FormEmitBilletDetails } from '../components/form-emit-billet-details/form-emit-billet-details';
import { ModalAlertComponent } from 'src/app/views/themes/sentinel/modals/modal-alert/modal-alert.component';
import { BilletDiscountDetailsRequestDto, BilletDiscountRequestDto, BilletDiscountTypeEnum, BilletFeeRequestDto, BilletFineRequestDto, BilletInterestTypeEnum, BilletLotService, BilletPayerRequestDTO, BilletProtestRequestDto, BilletProtestTypeEnum, BilletService, BilletSpecieTypeEnum, BilletTrafficTicketTypeEnum, CreateLotRequestDto, CreateRechargeRequestDto, LotStatusEnum } from '@wlp/ui-bs-cashin';
import { UserInfoService } from '@wlp/ui-bs-login';
import { LoadingService } from 'src/app/core/layout/services/loading.service';
import { UserInfoProfile } from '@wlp/ui-bs-login/lib/dto/user-info-profile';
import { ModalBilletFavorites } from 'src/app/views/themes/sentinel/modals/modal-billet-favorites/modal-billet-favorites.component';
import { ModalBilletJurosComponent } from 'src/app/views/themes/sentinel/modals/modal-billet-juros/modal-billet-juros.component';
import { billetDiscountDaysValidator } from './validators/billet-Interest-due-date-validator';
import { billetTrafficTicketValidator } from './validators/billet-traffic-ticket-due-date-validator';
import { billetInterestValidator } from './validators/discount-due-date-validator';

@Component({
  selector: 'ui-t-lot-emit-detailed',
  templateUrl: './lot-emit-detailed.page.html',
  styleUrls: ['./lot-emit-detailed.page.scss'],
})
export class CharginBilletLotEmitDetailed implements OnInit {
  @ViewChild(FormEmitBilletDetails, { static: false }) formEmitBilletDetails: FormEmitBilletDetails;

  private langDefault: string;
  private layoutConfigValue: LayoutConfigModel;

  userProfile: UserInfoProfile;
  billetLotForm: FormGroup;
  billetForm: FormGroup;
  payerForm: FormGroup;

  descriptionCounter = 0

  billetIdInCreation = 0

  discounts: any

  costPerBillet: number;

  specieTypeOptions = Object.keys(BilletSpecieTypeEnum);
  specieTypeSelected: BilletSpecieTypeEnum = null;

  customPopoverOptionsSpecieTypeSelect: any

  protestSelected = ''
  billetInterestTypeSelected = ''
  billetTrafficTicketTypeSelected = ''

  constructor(
    private formBuilder: FormBuilder,
    private navCtrl: NavController,
    public modalController: ModalController,
    private layoutConfigService: LayoutConfigService,
    protected userInfoService: UserInfoService,
    private loadingService: LoadingService,
    private translate: UiBsTranslateService,
    private billetLotService: BilletLotService,
    private serviceBillet: BilletService,
    private cd: ChangeDetectorRef,
  ) {
    moment.locale('pt-br');
  }

  ngOnInit(): void {
    this.layoutConfigValue = this.layoutConfigService.getSavedConfig();
    this.langDefault = this.layoutConfigValue.wlTheme.languageDefault;
    this.translate.setDefaultLang(this.langDefault);
    this.loadUser();
    this.createLotForm();

    this.customPopoverOptionsSpecieTypeSelect = {
      header: this.translate.applyTranslate('CASH_OUT.BILLET_LOT_EMIT_PAGE.FEES.TITLE')
    };
  }

  async loadUser() {
    try {
      this.userProfile = await this.userInfoService.getInfoProfile();
      this.getTaxBillet(this.userProfile.uuidWhiteLabel, this.userProfile.uuidAccount);
    } catch (e) {
      console.error('Failed to load user details', e);
    }
  }

  private async getTaxBillet(uuidWhiteLabel: string, uuidAccount: string) {
    const res = await this.serviceBillet.getBilletCreateTax(uuidWhiteLabel, uuidAccount, '701');
    if (res) {
      this.costPerBillet = res.value;
    }
  }

  createLotForm() {
    this.billetLotForm = this.formBuilder.group({
      billets: this.formBuilder.array([this.createBilletForm()]),
      specieType: new FormControl('', Validators.compose([Validators.required])),
      requestDescription: new FormControl('', Validators.compose([Validators.required])),
    });
  }

  createBilletForm(): FormGroup {
    this.billetForm = new FormGroup({
      withdrawn: this.createPayerForm(),
      value: new FormControl('', Validators.compose([Validators.required])),
      billetDueTime: new FormControl(
        '',
        Validators.compose([Validators.required, Validators.pattern('[0-9]{2}/[0-9]{2}/[0-9]{4}'), this.DateValidator])
      ),
      billetDateLimitPayment: new FormControl(
        '',
        Validators.compose([Validators.required, Validators.pattern('[0-9]{2}/[0-9]{2}/[0-9]{4}'), this.DateValidator])
      ),
      requestNumber: new FormControl('', Validators.compose([Validators.required,
      Validators.maxLength(10),
      Validators.pattern('[a-z0-9a-uA-ZA-U.-]{0,10}')])),

      hasProtest: new FormControl(false),
      protestType: new FormControl(''),
      protestDays: new FormControl(''),
      
      hasInterestAndTrafficTicket: new FormControl(false),
      billetInterestType: new FormControl(''),
      billetInterestValue: new FormControl(''),
      billetInterestDays: new FormControl(''),
      billetTrafficTicketType: new FormControl(''),
      billetTrafficTicketValue: new FormControl(''),
      billetTrafficTicketDays: new FormControl(''),

      hasDiscount: new FormControl(false),
      discounts: this.formBuilder.array([this.createDiscountForm()]),
      billetDiscountType: new FormControl(''),
    });
    return this.billetForm;
  }

  createPayerForm(): FormGroup {
    this.payerForm = new FormGroup({
      name: new FormControl('', Validators.compose([Validators.required])),
      email: new FormControl('', Validators.compose([Validators.required, Validators.email])),
      document: new FormControl('', Validators.compose([Validators.required])),
      documentType: new FormControl('', Validators.compose([Validators.required])),
      zipCode: new FormControl('', Validators.compose([Validators.required])),
      street: new FormControl('', Validators.compose([Validators.required])),
      streetNumber: new FormControl('', Validators.compose([Validators.required])),
      streetComplement: new FormControl(''),
      city: new FormControl('', Validators.compose([Validators.required])),
      neighborhood: new FormControl('', Validators.compose([Validators.required])),
      state: new FormControl('', Validators.compose([Validators.required])),
    })
    return this.payerForm;
  }

  DateValidator(control: FormControl): { [key: string]: any } {
    const dateSplited = control.value.split('/');
    const date = moment(new Date(+dateSplited[2], dateSplited[1] - 1, +dateSplited[0]));

    if (!(date.isValid() && date.isSameOrAfter(moment()))) {
      return { DateValidator: true };
    }

    return null;
  }

  private errorMessages = {
    value: [
      {
        type: 'required',
        message: 'CASH_OUT.BILLET_LOT_EMIT_PAGE.VALIDATION.BILLET_VALUE.REQUIRED',
      },
      {
        type: 'min',
        message: 'CASH_OUT.BILLET_LOT_EMIT_PAGE.VALIDATION.BILLET_VALUE.MIN',
        param: { min: 1 },
      },
    ],
    requestNumber: [
      {
        type: 'pattern', 
        message: 'CASH_OUT.BILLET_LOT_EMIT_PAGE.VALIDATION.DOC_NUMBER.PATTERN'
      },
      {
        type: 'maxlength',
        param: { maxLength: 10 },
      },
      {
        type: "required",
        message: 'CASH_OUT.BILLET_LOT_EMIT_PAGE.VALIDATION.DOC_NUMBER.REQUIRED',
      }
    ],
    requestDescription: [
      {
        type: 'required',
        message: 'CASH_OUT.BILLET_LOT_EMIT_PAGE.VALIDATION.DESCRIPTION.REQUIRED',
      },
    ],
    billetDueTime: [
      {
        type: "required",
        message: 'CASH_OUT.BILLET_LOT_EMIT_PAGE.VALIDATION.BILLET_DUE_TIME.REQUIRED',
      },
      {
        type: 'DateValidator',
        message: 'CASH_OUT.BILLET_LOT_EMIT_PAGE.VALIDATION.BILLET_DUE_TIME.DATE_VALIDATOR'
      }
    ],
    billetDateLimitPayment: [
      {
        type: "required",
        message: 'CASH_OUT.BILLET_LOT_EMIT_PAGE.VALIDATION.BILLET_DATE_LIMIT_PAYMENT.REQUIRED',
      },
      {
        type: 'DateValidator',
        message: 'CASH_OUT.BILLET_LOT_EMIT_PAGE.VALIDATION.BILLET_DATE_LIMIT_PAYMENT.DATE_VALIDATOR'
      }
    ],
    protestType: [
      {
        type: 'required',
        message: 'CASH_OUT.BILLET_LOT_EMIT_PAGE.VALIDATION.PROTEST_TYPE.REQUIRED',
      }
    ],
    protestDays: [
      {
        type: 'min',
        message: 'CASH_OUT.BILLET_LOT_EMIT_PAGE.VALIDATION.PROTEST_DAYS.MIN'
      },
      {
        type: 'max',
        message: 'CASH_OUT.BILLET_LOT_EMIT_PAGE.VALIDATION.PROTEST_DAYS.MAX'
      },
      {
        type: 'required',
        message: 'CASH_OUT.BILLET_LOT_EMIT_PAGE.VALIDATION.PROTEST_DAYS.REQUIRED',
      }
    ],
    billetInterestType: [
      {
        type: 'required',
        message: 'CASH_OUT.BILLET_LOT_EMIT_PAGE.VALIDATION.BILLET_INTEREST_TYPE.REQUIRED',
      }
    ],
    billetInterestValue: [
      {
        type: 'required',
        message: 'CASH_OUT.BILLET_LOT_EMIT_PAGE.VALIDATION.BILLET_INTEREST_VALUE.REQUIRED',
      }
    ],
    billetInterestDays: [
      {
        type: 'required',
        message: 'CASH_OUT.BILLET_LOT_EMIT_PAGE.VALIDATION.BILLET_INTEREST_DAYS.REQUIRED',
      },
      {
        type: 'billetInterestValidator',
        message: 'CASH_OUT.BILLET_LOT_EMIT_PAGE.VALIDATION.BILLET_INTEREST_DAYS.BILLET_INTEREST_VALIDATOR'
      }
    ],
    billetTrafficTicketType: [
      {
        type: 'required',
        message: 'CASH_OUT.BILLET_LOT_EMIT_PAGE.VALIDATION.BILLET_TRAFFIC_TICKET_TYPE.REQUIRED',
      },
    ],
    billetTrafficTicketValue: [
      {
        type: 'required',
        message: 'CASH_OUT.BILLET_LOT_EMIT_PAGE.VALIDATION.BILLET_TRAFFIC_TICKET_VALUE.REQUIRED',
      },
    ],
    billetTrafficTicketDays: [
      {
        type: 'required',
        message: 'CASH_OUT.BILLET_LOT_EMIT_PAGE.VALIDATION.BILLET_TRAFFIC_TICKET_DAYS.REQUIRED',
      },
      {
        type: 'billetTrafficTicketValidator',
        message: 'CASH_OUT.BILLET_LOT_EMIT_PAGE.VALIDATION.BILLET_TRAFFIC_TICKET_DAYS.BILLET_TRAFFIC_TICKET_VALIDATOR'
      }
    ],
    billetDiscountType: [
      {
        type: 'required',
        message: 'CASH_OUT.BILLET_LOT_EMIT_PAGE.VALIDATION.BILLET_DISCOUNT_TYPE.REQUIRED',
      },
    ],
    billetDiscountValue: [
      {
        type: 'required',
        message: 'CASH_OUT.BILLET_LOT_EMIT_PAGE.VALIDATION.BILLET_DISCOUNT_VALUE.REQUIRED',
      },
    ],
    billetDiscountDays: [
      {
        type: 'required',
        message: 'CASH_OUT.BILLET_LOT_EMIT_PAGE.VALIDATION.BILLET_DISCOUNT_DAYS.REQUIRED',
      },
      {
        type: 'billetDiscountDaysValidator',
        message: 'CASH_OUT.BILLET_LOT_EMIT_PAGE.VALIDATION.BILLET_DISCOUNT_DAYS.BILLET_DISCOUNT_VALIDATOR'
      }
    ]
  }

  getErrorMessages() {
    return this.errorMessages;
  }

  handleDescriptionChange(description) {
    this.descriptionCounter = description.length;
  }

  checkValue(value) {
    value = value.replace(/[^\w\s]/gi, '');
    value = parseFloat(value);
    if (value < 100) {
      this.billetForm.controls.value.setErrors({ min: true });
    }
  }

  removeSpaces(event: any) {
    const input = event.target.value;
    event.target.value = input.replace(/\s/g, '');
  }

  protestBlockedField(billetSelected) {
    const protestType = billetSelected.controls.protestType.value;
    return protestType === 'NOT_PROTEST' || protestType === 'CANCEL_PROTEST' || protestType === '';
  }

  get billets(): FormArray {
    return this.billetLotForm.get('billets') as FormArray;
  }

  goBack() {
    this.navCtrl.navigateRoot('/app/dashboard');
  }

  goToNextPage(uuidAccountPayment: string, uuidLot: string) {
    const uri = `/app/charging/billet/v2/emit-confirmation-multi/${uuidAccountPayment}/${uuidLot}`
    this.navCtrl.navigateRoot(uri)
  }

  addBillet() {
    this.billets.push(this.createBilletForm());
  }

  removeBillet(index: any) {
    this.billets.removeAt(index);
  }

  createDiscountForm(): FormGroup {
    const discountForm = this.formBuilder.group({
      billetDiscountValue: new FormControl(''),
      billetDiscountDays: new FormControl(''),
    });

    return discountForm;
  }

  addDiscount(hasValidator, discounts, currentBillet) {
    this.discounts.push(this.createDiscountForm());
    if (hasValidator) {
      this.onChangeDiscountTypeSelectField({ detail: { value: 'AddDiscount' }}, discounts, currentBillet)
    }
  }

  removeDiscount(lessonIndex: number) {
    if (this.discounts.length > 0) {
      this.discounts.removeAt(lessonIndex);
    }
  }

  getFees(currentBillet): BilletFeeRequestDto {
    const feesInputToEnum = (value: string): BilletInterestTypeEnum => {
      switch (value) {
        case 'DAYS_INTEREST':
          return BilletInterestTypeEnum.DAYS_INTEREST;
        case 'PROPORTIONAL_INTEREST':
          return BilletInterestTypeEnum.PROPORTIONAL_INTEREST;
      }
      return null;
    };

    const feesType = currentBillet.controls.billetInterestType.value;
    const feesValue = currentBillet.controls.billetInterestValue.value.replace(',', '.');
    const feesDays = (currentBillet.controls.billetInterestDays.value).trim().split('/').reverse().join('-');
    const selectedFees = feesInputToEnum(feesType);
    if (selectedFees == null) return null;
    return {
      type: selectedFees,
      value: feesValue,
      expirationDate: feesDays,
    };
  }

  getFine(currentBillet): BilletFineRequestDto {
    const fineInputToEnum = (value: string): BilletTrafficTicketTypeEnum => {
      switch (value) {
        case 'FREE_TICKET':
          return BilletTrafficTicketTypeEnum.FREE_TICKET;
        case 'FIXED_TICKET':
          return BilletTrafficTicketTypeEnum.FIXED_TICKET;
        case 'PROPORTIONAL_TICKET':
          return BilletTrafficTicketTypeEnum.PROPORTIONAL_TICKET;
      }
      return null;
    };

    const fineType = currentBillet.controls.billetTrafficTicketType.value;
    const finevalue = currentBillet.controls.billetTrafficTicketValue.value.replace(',', '.');
    const fineDays = (currentBillet.controls.billetTrafficTicketDays.value).trim().split('/').reverse().join('-');
    const selectedFine = fineInputToEnum(fineType);
    if (selectedFine == null) return null;

    return {
      type: selectedFine,
      value: finevalue,
      expirationDate: fineDays,
    };
  }

  getDiscounts(currentBillet: FormGroup): BilletDiscountRequestDto{
    const discountCount = currentBillet.controls.discounts['controls'].length;
    const discountDetails = [];
    for (let i = 0; i < discountCount; i++) {
      const details: BilletDiscountDetailsRequestDto = {
        value: currentBillet.controls.discounts['controls'][i].controls.billetDiscountValue.value.replace(',', '.'),
        expirationDate: (currentBillet.controls.discounts['controls'][i].controls.billetDiscountDays.value).trim().split('/').reverse().join('-')
      };
      discountDetails.push(details);
    }

    const discountInputToEnum = (value: string): BilletDiscountTypeEnum => {
      switch (value) {
        case '0':
          return BilletDiscountTypeEnum.NOT_DISCOUNT;
        case '1':
          return BilletDiscountTypeEnum.FIXED_DISCOUNT;
        case '2':
          return BilletDiscountTypeEnum.PROPORTIONAL_DISCOUNT;
        case '3':
          return BilletDiscountTypeEnum.FIXED_IN_ADVANCE_DISCOUNT;
        case '4':
          return BilletDiscountTypeEnum.PROPORTIONAL_IN_ADVANCE_DISCOUNT;
      }
      return null;
    };

    const selectedDiscount = discountInputToEnum(
      currentBillet.controls.billetDiscountType.value
    );

    if (selectedDiscount == null) return null;

    return {
      type: selectedDiscount,
      details: discountDetails,
    };
  }

  getProtest(currentBillet): BilletProtestRequestDto {
    const protestType = currentBillet.controls.protestType.value;
    const protestDays = currentBillet.controls.protestDays.value;
    if (!protestType) return null;

    return {
      type: protestType,
      days: protestDays,
    };
  }

  handleSubmitForm(): void {
    const billets = [];
    const billetCount = this.billetLotForm.controls.billets['controls'].length;

    const description = this.billetLotForm.controls.requestDescription.value
    const specieTypeSelected = this.billetLotForm.controls.specieType.value;

    if (!specieTypeSelected) {
      this.billetLotForm.controls['specieType'].markAsDirty();
      this.statusNotification('warning-circle', 'CASH_OUT.BILLET_LOT_EMIT_PAGE.VALIDATION.SPECIE_TYPE_REQUIRED', true);
      return null;
    }

    const billetInputIsValid = (form: FormGroup, fields: string[]): boolean => {
      let isValid: boolean = true;
      for (var field of fields) {
        form.controls[field].markAsTouched();
        if (!form.controls[field].valid) {
          isValid = false;
        }
      }
      return
    };

    const billetFields = ['billetDueTime', 'requestNumber', 'billetDateLimitPayment', 'value'];

    for (let i = 0; i < billetCount; i++) {
      const currentBillet = this.billetLotForm.controls.billets['controls'][i];
      const formPayer = currentBillet.get('withdrawn');

      const dateDue = currentBillet.controls.billetDueTime.value;
      const requestNumber = currentBillet.controls.requestNumber.value;
      const dateLimitPayment = currentBillet.controls.billetDateLimitPayment.value;
      const value = currentBillet.controls.value.value;

      const hasDiscount = currentBillet.controls.hasDiscount.value
      const discount = hasDiscount ? this.getDiscounts(currentBillet) : null;

      const hasInterestAndTrafficTicket = currentBillet.controls.hasInterestAndTrafficTicket
      const fees = hasInterestAndTrafficTicket ? this.getFees(currentBillet) : null;
      const fine = hasInterestAndTrafficTicket ? this.getFine(currentBillet) : null;

      const hasProtest = currentBillet.controls.hasProtest.value
      const protest = hasProtest ? this.getProtest(currentBillet) : null;

      const dateDueFormated = dateDue.trim().split('/').reverse().join('-');
      const dateLimitPaymentFormated = dateLimitPayment.trim().split('/').reverse().join('-');

      const today = new Date();
      if (
        today.getTime() > new Date(dateDueFormated).getTime() ||
        today.getTime() > new Date(dateLimitPaymentFormated).getTime()
      ) {
        this.statusNotification('warning-circle', 'COMMOM.VALIDATION.INVALID_DATE', true);
        return null;
      }

      const payer: BilletPayerRequestDTO = {
        name: formPayer.get('name').value,
        email: formPayer.get('email').value,
        document: formPayer.get('document').value,
        documentType: formPayer.get('documentType').value,
        address: {
          zipCode: formPayer.get('zipCode').value,
          street: formPayer.get('street').value,
          streetNumber: formPayer.get('streetNumber').value,
          streetComplement: formPayer.get('streetComplement').value,
          neighborhood: formPayer.get('neighborhood').value,
          city: formPayer.get('city').value,
          state: formPayer.get('state').value,
        },
      }

      const billet: CreateRechargeRequestDto = {
        requestNumber,
        value,
        dateDue: dateDueFormated,
        payer,
        dateLimitPayment: dateLimitPaymentFormated,
        specieType: specieTypeSelected,
        fees,
        fine,
        discount,
        protest,
        transactionId: '',
        uuidWhiteLabel: this.userProfile.uuidWhiteLabel,
        uuidAccountPaymet: this.userProfile.uuidAccount,
      };
      billets.push(billet);
    }

    const body: CreateLotRequestDto = {
      uuidWhiteLabel: this.userProfile.uuidWhiteLabel,
      name: '',
      description: description,
      status: LotStatusEnum.DRAFT,
      billets: billets,
    };

    this.createLot(body);
  }

  createLot(createLotRequestDto: CreateLotRequestDto) {
    this.loadingService.show();
    this.billetLotService.createLot(createLotRequestDto).subscribe(
      (res) => {
        this.loadingService.hide();
        // @ts-ignore
        if (res.statusCode && res.statusCode !== 200) {
          this.statusNotification('warning-circle', 'CASH_OUT.BILLET_LOT_EMIT_PAGE.MESSAGES.CREATE_LOT_FAILED', true);
          return;
        }
        this.goToNextPage(res.uuidAccountPayment, res.uuid);
      },
      (error: any) => {
        console.log('error: ', error);
        this.loadingService.hide();
      }
    );
  }

  private async statusNotification(status: string, message: string, translateFlag: boolean) {
    const translate = translateFlag ? true : false;
    const modalStatus = await this.modalController.create({
      component: ModalAlertComponent,
      cssClass: 'modal-alert-class',
      componentProps: {
        status: status,
        message,
        confirmBtn: 'CASH_OUT.ACCOUNT_CHARGING.CLOSE_BUTTON',
        translate: translate,
        hasActionAfterConfirmation: true,
      },
      backdropDismiss: false,
    });
    return await modalStatus.present();
  }

  private async modalJuros(i: number) {
    const billetSelected = this.billetLotForm.get("billets")['controls'][i]

    const hasProtest = billetSelected.controls.hasProtest as FormControl
    hasProtest.setValue(billetSelected.controls.protestType.value !== "")
    this.protestSelected = billetSelected.controls.protestType.value

    const fineValue = billetSelected.value.billetTrafficTicketType

    const hasInterestAndTrafficTicket = billetSelected.controls.hasInterestAndTrafficTicket as FormControl
    hasInterestAndTrafficTicket.setValue(billetSelected.controls.billetInterestType.value !== '' || billetSelected.controls.billetTrafficTicketType.value !== '')
    hasProtest.setValue(billetSelected.controls.protestType.value !== "")
    this.billetInterestTypeSelected = billetSelected.controls.billetInterestType.value
    this.billetTrafficTicketTypeSelected = billetSelected.controls.billetTrafficTicketType.value

    this.discounts = billetSelected.get("discounts") as FormArray
    const hasDiscount = billetSelected.controls.hasDiscount as FormControl
    hasDiscount.setValue((billetSelected.controls.billetDiscountType.value !== ""))

    const modalJuros = await this.modalController.create({
      component: ModalBilletJurosComponent,
      cssClass: 'modal-billet-juros',
      componentProps: {
        billetForm: billetSelected,

        hasProtest: hasProtest,
        protestSelected: this.protestSelected,

        fineValue: fineValue,

        hasInterestAndTrafficTicket: hasInterestAndTrafficTicket,
        billetInterestTypeSelected: this.billetInterestTypeSelected,
        billetTrafficTicketTypeSelected: this.billetTrafficTicketTypeSelected,

        hasDiscount: hasDiscount,
        discounts: this.discounts,

        createDiscountForm: this.createDiscountForm,
        addDiscount: this.addDiscount,
        removeDiscount: this.removeDiscount,

        protestBlockedField: this.protestBlockedField,
        onToggleChange: this.onToggleChange,

        onChangeProtestSelectField: this.onChangeProtestSelectField,
        onChangeInterestTypeSelectField: this.onChangeInterestTypeSelectField,
        onChangeTrafficTicketTypeSelectField: this.onChangeTrafficTicketTypeSelectField,
        onChangeDiscountTypeSelectField: this.onChangeDiscountTypeSelectField,

        errorMessages: this.errorMessages,
      },

    });
    modalJuros.onDidDismiss().then(() => {});
    return await modalJuros.present();
  }

  async openModalfavorites(index) {
    this.billetIdInCreation = index

    const ModalLotBilletFavorites = await this.modalController.create({
      component: ModalBilletFavorites,
      cssClass: 'modal-billet-lot',
      backdropDismiss: false,
      componentProps: {
        onSubmit: (payer: BilletPayerRequestDTO) => {
          const currentBillet = this.billets.controls[index];
          this.setPayerFromModalToBillet(payer, currentBillet);
          ModalLotBilletFavorites.dismiss();
        }
      }
    });
    return await ModalLotBilletFavorites.present();
  }


  setPayerFromModalToBillet(payer: BilletPayerRequestDTO, billet: AbstractControl) {
    const currentBilletPayerForm = billet.get('withdrawn') as FormGroup;

    const controlsForm = currentBilletPayerForm.controls
    
    const formPayerData = {
      name: payer.name,
      email: payer.email,
      document: payer.document,
      documentType: payer.documentType,
      zipCode: payer.address.zipCode,
      street: payer.address.street,
      streetNumber: payer.address.streetNumber,
      streetComplement: payer.address.streetComplement,
      city: payer.address.city,
      neighborhood: payer.address.neighborhood,
      state: payer.address.state,
    };

    Object.keys(controlsForm).map(key => {
      controlsForm[key].setValue(formPayerData[key])
    })
  }

  onToggleChange(event, formControl: FormControl, formChanged: string, currentDiscountForm: FormArray, currentBillet: FormGroup) {
    formControl.setValue(event.detail.checked)

    if(!event.detail.checked) {
      switch (formChanged) {
        case 'hasProtest':
          currentBillet.controls.protestType.setValue('')
          currentBillet.controls.protestDays.setValue('')
          this.protestSelected = ''

          currentBillet.controls.protestType.clearValidators()
          currentBillet.controls.protestDays.clearValidators()
        return

        case 'hasInterestAndTrafficTicket': 
          currentBillet.controls.billetInterestType.setValue('')
          currentBillet.controls.billetInterestValue.setValue('')
          currentBillet.controls.billetInterestDays.setValue('')
          this.billetInterestTypeSelected = ''
    
          currentBillet.controls.billetInterestType.clearValidators()
          currentBillet.controls.billetInterestValue.clearValidators()
          currentBillet.controls.billetInterestDays.clearValidators()
    
          currentBillet.controls.billetTrafficTicketType.setValue('')
          currentBillet.controls.billetTrafficTicketValue.setValue('')
          currentBillet.controls.billetTrafficTicketDays.setValue('')
          this.billetTrafficTicketTypeSelected = ''
    
          currentBillet.controls.billetTrafficTicketType.clearValidators()
          currentBillet.controls.billetTrafficTicketValue.clearValidators()
          currentBillet.controls.billetTrafficTicketDays.clearValidators()
        return

        case 'hasDiscount':
          currentDiscountForm.clear()
          this.addDiscount(false, currentDiscountForm, currentBillet) 
        return
      }
    }

    this.cd.detectChanges();
  }

  onChangeProtestSelectField(event, billetSelected) {
    const hasProtest = event.detail.value === BilletProtestTypeEnum.EFFECTIVE_PROTEST

    const protestTypeControl = billetSelected.controls.protestType as FormControl
    const protestDaysControl = billetSelected.controls.protestDays as FormControl

    if (hasProtest) {
      protestTypeControl.setValidators(Validators.required)
      protestDaysControl.setValidators(Validators.compose([Validators.min(1), Validators.max(99), Validators.required]))

      protestDaysControl.markAsTouched()
      protestDaysControl.updateValueAndValidity()
    } else {
      protestDaysControl.markAsUntouched()
      protestDaysControl.clearValidators()
    }

    this.cd.detectChanges();
  }

  onChangeInterestTypeSelectField(event, billetSelected) {
    const hasInterest = event.detail.value !== ""

    const billetInterestTypeControl = billetSelected.controls.billetInterestType
    const billetInterestValueControl = billetSelected.controls.billetInterestValue
    const billetInterestDaysControl = billetSelected.controls.billetInterestDays

    if (hasInterest) {
      billetInterestTypeControl.setValidators(Validators.required)
      billetInterestValueControl.setValidators(Validators.required)
      billetInterestDaysControl.setValidators(Validators.compose([Validators.required, billetInterestValidator(billetSelected)]))


      billetInterestValueControl.markAsTouched()
      billetInterestDaysControl.markAsTouched()

      billetInterestValueControl.updateValueAndValidity()
      billetInterestDaysControl.updateValueAndValidity()
    } else {
      billetInterestValueControl.markAsUntouched()
      billetInterestDaysControl.markAsUntouched()
    }

    this.cd.detectChanges();

  }

  onChangeTrafficTicketTypeSelectField(event, billetSelected) {
    const hasTrafficTicket = event.detail.value !== "" && event.detail.value !== "FREE_TICKET"

    const billetTrafficTicketTypeControl = billetSelected.controls.billetTrafficTicketType
    const billetTrafficTicketValueControl = billetSelected.controls.billetTrafficTicketValue
    const billetTrafficTicketDaysControl = billetSelected.controls.billetTrafficTicketDays

    if (hasTrafficTicket) {
      billetTrafficTicketTypeControl.setValidators(Validators.required)
      billetTrafficTicketValueControl.setValidators(Validators.required)
      billetTrafficTicketDaysControl.setValidators(Validators.compose([Validators.required, billetTrafficTicketValidator(billetSelected)]))


      billetTrafficTicketValueControl.markAsTouched()
      billetTrafficTicketDaysControl.markAsTouched()

      billetTrafficTicketValueControl.updateValueAndValidity()
      billetTrafficTicketDaysControl.updateValueAndValidity()
    } else {
      billetTrafficTicketValueControl.markAsUntouched()
      billetTrafficTicketDaysControl.markAsUntouched()
    }

    this.cd.detectChanges();
  }

  onChangeDiscountTypeSelectField(event, discountForms, selectedBillet) {
    const hasDiscount = event.detail.value === "1" ||  event.detail.value === "2" || event.detail.value === "AddDiscount" 
    
    let billetDiscountDaysControl: FormControl
    let billetDiscountValueControl: FormControl
    const billetDiscountTypeControl = selectedBillet.controls.billetDiscountType as FormControl

    if (event.detail.value === '0') {
      discountForms.clear()
      this.addDiscount(false, discountForms, selectedBillet)
    }

    discountForms.controls.map(discountControl => {
      billetDiscountDaysControl = discountControl.controls.billetDiscountDays as FormControl
      billetDiscountValueControl = discountControl.controls.billetDiscountValue as FormControl

      if (hasDiscount) {
        billetDiscountDaysControl.setValidators(Validators.compose([billetDiscountDaysValidator(selectedBillet), Validators.required]))
        billetDiscountValueControl.setValidators(Validators.required)
        
        billetDiscountDaysControl.markAsTouched()
        billetDiscountValueControl.markAsTouched()
        
    
        billetDiscountDaysControl.updateValueAndValidity()
        billetDiscountValueControl.updateValueAndValidity()
  
      } else {
        billetDiscountTypeControl.markAllAsTouched()
        billetDiscountTypeControl.clearValidators()
      }
    })
    
    this.cd.detectChanges();
  }

}
